import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkIcon", "copyButton", "copyIcon", "panel", "shareButton"]
  static values = { url: String }

  disconnect() {
    if (this.feedbackTimeout) clearTimeout(this.feedbackTimeout)
  }

  toggle() {
    const visible = this.panelTarget.classList.toggle("visible")
    this.shareButtonTarget.setAttribute("aria-expanded", visible)
  }

  copy() {
    navigator.clipboard?.writeText?.(this.urlValue)?.catch(() => {})
    this.copyButtonTarget.classList.add("pulse")
    this.copyIconTarget.classList.remove("active")
    this.checkIconTarget.classList.add("active")

    if (this.feedbackTimeout) clearTimeout(this.feedbackTimeout)
    this.feedbackTimeout = setTimeout(() => this.resetCopyFeedback(), 500)
  }

  resetCopyFeedback() {
    this.copyButtonTarget.classList.remove("pulse")
    this.copyIconTarget.classList.add("active")
    this.checkIconTarget.classList.remove("active")
  }
}
